import { DomainError } from './DomainError';

const LOGICAL_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function isLogicalDate(value: string): boolean {
  const match = LOGICAL_DATE_PATTERN.exec(value);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() + 1 === month &&
    parsed.getUTCDate() === day
  );
}

export function addLogicalDays(logicalDate: string, days: number): string {
  if (!isLogicalDate(logicalDate) || !Number.isInteger(days)) {
    throw new DomainError('invalid_logical_date', 'Cette date n’est pas valide.');
  }

  const [year, month, day] = logicalDate.split('-').map(Number) as [number, number, number];
  const result = new Date(Date.UTC(year, month - 1, day + days));
  return [result.getUTCFullYear(), result.getUTCMonth() + 1, result.getUTCDate()]
    .map((value, index) => (index === 0 ? String(value) : String(value).padStart(2, '0')))
    .join('-');
}

export function dayOfWeek(logicalDate: string): number {
  if (!isLogicalDate(logicalDate)) {
    throw new DomainError('invalid_logical_date', 'Cette date n’est pas valide.');
  }
  const [year, month, day] = logicalDate.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
}
